export default "__VITE_ASSET__DmpRWUbj__"